import { render, staticRenderFns } from "./AdminAddPastor.vue?vue&type=template&id=2aedb5a0&scoped=true&"
import script from "./AdminAddPastor.vue?vue&type=script&lang=js&"
export * from "./AdminAddPastor.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddPastor.vue?vue&type=style&index=0&id=2aedb5a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aedb5a0",
  null
  
)

export default component.exports